export const CREATING = "creating";
export const SAVED = "saved";
export const UNSAVED = "unsaved";

export const CREATE = "NV.CREATE";
export const FAIL = "NV.FAIL";
export const SUCCEED = "NV.SUCCEED";
